import { RStoreSchema } from '#imports';
import { User } from '~/rstore/schema/system/user';
import { Collection } from '~/rstore/schema/workspace/schema/collection';
import { Block } from './block';
import { File } from './file';
import { KeyStorage } from './key-storage';
import { Page, PageSection, Space } from './spaces';

// Space relations
export const SpaceRelations = RStoreSchema.defineRelations(Space, ({ collection }) => ({
	block: {
		to: collection(Block, {
			on: {
				'MonospaceBlock.spaceId': 'MonospaceSpace.id',
			},
		}),
	},
	pages: {
		to: collection(Page, {
			on: {
				'MonospacePage.spaceId': 'MonospaceSpace.id',
			},
		}),
		many: true,
	},
	sections: {
		to: collection(PageSection, {
			on: {
				'MonospacePageSection.spaceId': 'MonospaceSpace.id',
			},
		}),
		many: true,
	},
}));

export const PageRelations = RStoreSchema.defineRelations(Page, ({ collection }) => ({
	block: {
		to: collection(Block, {
			on: {
				'MonospaceBlock.pageId': 'MonospacePage.id',
			},
		}),
	},
	space: {
		to: collection(Space, {
			on: {
				'MonospaceSpace.id': 'MonospacePage.spaceId',
			},
		}),
	},
	section: {
		to: collection(PageSection, {
			on: {
				'MonospacePageSection.id': 'MonospacePage.sectionId',
			},
		}),
	},
	collection: {
		to: collection(Collection, {
			on: {
				'MonospaceCollection.id': 'MonospacePage.collectionId',
			},
		}),
	},
}));

export const PageSectionRelations = RStoreSchema.defineRelations(PageSection, ({ collection }) => ({
	pages: {
		to: collection(Page, {
			on: {
				'MonospacePage.sectionId': 'MonospacePageSection.id',
			},
		}),
		many: true,
	},
	space: {
		to: collection(Space, {
			on: {
				'MonospaceSpace.id': 'MonospacePageSection.spaceId',
			},
		}),
	},
}));

// KeyStorage relations
export const KeyStorageRelations = RStoreSchema.defineRelations(KeyStorage, ({ collection }) => ({
	owner: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceKeyStorage.ownerId',
			},
		}),
	},
	collection: {
		to: collection(Collection, {
			on: {
				'MonospaceCollection.id': 'MonospaceKeyStorage.collectionId',
			},
		}),
	},
	block: {
		to: collection(Block, {
			on: {
				'MonospaceBlock.id': 'MonospaceKeyStorage.blockId',
			},
		}),
	},
}));

// File relations
export const FileRelations = RStoreSchema.defineRelations(File, ({ collection }) => ({
	$thumbnail: {
		to: collection(File, {
			on: {
				'MonospaceFile.id': 'MonospaceFile.id',
			},
		}),
	},
}));
